import { HTMLProps, JSX } from "react";

import "./SideMenu.scss";

type SideMenuProps = {
  title: JSX.Element;
} & Omit<HTMLProps<HTMLDivElement>, "title">;

function SideMenu({
  title = <></>,
  children,
  className = "mr-relative mb-relative"
}: SideMenuProps) {
  return (
    <div className={`side-menu ${className || ""} box pt-5 no-print`}>
      <label className="x-small">Meny</label>
      <h4 className="my-3">{title}</h4>
      <hr className="side-menu-border" />
      {children}
    </div>
  );
}

export { SideMenu };
